var _classCallCheck = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var jsonld = require('jsonld');

var DataFactory = require('@rdfjs/data-model');

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function _class(options) {
    _classCallCheck(this, _class);

    this.documentIRI = options.documentIRI;
    this.factory = options.factory || DataFactory;
  }

  _createClass(_class, [{
    key: "term",
    value: function term(plainTerm) {
      switch (plainTerm.termType) {
        case 'NamedNode':
          return DataFactory.namedNode(plainTerm.value);

        case 'BlankNode':
          return DataFactory.blankNode(plainTerm.value.substr(2));

        case 'Literal':
          return DataFactory.literal(plainTerm.value, plainTerm.language || DataFactory.namedNode(plainTerm.datatype.value));

        case 'DefaultGraph':
          return DataFactory.defaultGraph();

        default:
          throw Error('unknown termType: ' + plainTerm.termType);
      }
    }
  }, {
    key: "addEqualsMethodToQuad",
    value: function addEqualsMethodToQuad(quad) {
      quad.subject = this.term(quad.subject);
      quad.predicate = this.term(quad.predicate);
      quad.object = this.term(quad.object);
      quad.graph = this.term(quad.graph);
      return quad;
    }
  }, {
    key: "parse",
    value: function parse(document, callback) {
      var _this = this;

      jsonld.toRDF(JSON.parse(document), {
        base: this.documentIRI
      }, function (error, quads) {
        for (var index in quads) {
          var quad = quads[index];
          callback(null, _this.addEqualsMethodToQuad(quad));

          if (index == quads.length - 1) {
            //This is the end
            callback(null, null);
          }
        }

        if (error) {
          callback(error);
        }
      });
    }
  }]);

  return _class;
}();